import { BASE_URL } from '../API/BASE_URL';

export const getPromotions = async () => {
  const response = await fetch(BASE_URL + 'shops/promotions/', {
    method: 'GET',
  });

  const data = await response.json();
  return data;
};
